﻿import {translation} from "@2d-front-monorepo/core";
import {
	useInitializeMvvmContext,
	MvvmDataProvider,
	MvvmDataProviderRef,
	MvvmOptionList,
	MvvmOptionListEntry
} from "@2d-front-monorepo/design-library";
import {JSX, RefObject, useMemo} from "react";
import {ParkingCategory} from "../nominalTypes/ParkingCategory";

export interface SelectEntityCategoryModel {
	category: ParkingCategory;
}

export interface SelectEntityCategoryProps {
	categories: ParkingCategory[];
	initialState: SelectEntityCategoryModel;
	onSubmit: (formData: SelectEntityCategoryModel) => Promise<void>;
	contextRef?: RefObject<MvvmDataProviderRef<SelectEntityCategoryModel>>;
	children?: JSX.Element;
}

export default function SelectEntityCategoryComponent(props: SelectEntityCategoryProps): JSX.Element {
	const {categories, initialState, onSubmit, contextRef, children} = props;

	const tariffTypes = useMemo<MvvmOptionListEntry<ParkingCategory>[]>(() =>
			categories.map(t => ({label: translation(`tariff-type-name__${t}`), value: t as ParkingCategory})),
		[categories]
	);

	const {context} = useInitializeMvvmContext({
		initialState: () => {
			const preSelected = tariffTypes.find(x => x.value === initialState.category);
			//categories can be legitimately empty during read-model lag — keep whatever was staged
			initialState.category = preSelected == null ? tariffTypes[0]?.value ?? initialState.category : preSelected.value;
			return initialState;
		},
		contextRef: contextRef
	}, [tariffTypes]);

	return <MvvmDataProvider<SelectEntityCategoryModel> onSubmit={onSubmit} context={context}>
		<MvvmOptionList context={context} property="category" items={tariffTypes}/>
		{children}
	</MvvmDataProvider>;
}
